import VisitFrequency from "../components/VisitFrequency";

export default function VisitFrequencyPage() {
  return <VisitFrequency />;
}
